import { render, staticRenderFns } from "./videoForm.vue?vue&type=template&id=3aa82793&scoped=true&"
import script from "./videoForm.vue?vue&type=script&lang=babel&"
export * from "./videoForm.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa82793",
  null
  
)

export default component.exports